module.exports = __webpack_public_path__ + "img/login-bg.a7aa53fc.jpg";